import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取大咖列表
 * @param data
 */
export function getAuthorList(data, viewState) {
  console.log(JSON.stringify(data))
  console.log(viewState)
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/Author/Page`,
    method: 'post',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取大咖详情
 * @param {number} setId 大咖id
 */
export function getAuthorDetail(authorId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/Author/Detail`,
    method: 'get',
    params: {
      authorId
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}
/**
 * 获取大咖锦囊
 * @param {number} setId 大咖id
 */
export function getJinNangList(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/Data/Page`,
    method: 'get',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(data => {
      return data
    })
    .catch(() => null)
}

/**
 * 获取大咖课程
 * @param {object} 查询条件
 */
export function getCourseList(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/Api/SetList`,
    method: 'post',
    data
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 获取大咖热卖锦囊
 */
export function getHotSaledJinNangList(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/Data/TopSaleList`,
    method: 'post',
    data
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}
